
import React, { useState, useEffect } from 'react';
import Layout from '@/components/Layout';
import UserProfile from '@/components/UserProfile';
import UpcomingSpecialDays from '@/components/UpcomingSpecialDays';
import { SpecialDay } from '@/utils/types';
import { checkForPersonalSpecialDay } from '@/services/notificationService';
import { Gift, Calendar } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const ProfilePage = () => {
  const [specialDays, setSpecialDays] = useState<SpecialDay[]>([]);
  const [hasCheckedSpecialDays, setHasCheckedSpecialDays] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    // Load preferences from localStorage if available
    const savedPrefs = localStorage.getItem('giftPreferences');
    if (savedPrefs) {
      try {
        const prefs = JSON.parse(savedPrefs);
        if (prefs.specialDays) {
          setSpecialDays(prefs.specialDays);
          
          // Only check for special days once when the component mounts
          if (!hasCheckedSpecialDays) {
            // Check if today is a special day or if there are upcoming special days when the profile loads
            checkForPersonalSpecialDay(prefs.specialDays);
            setHasCheckedSpecialDays(true);
          }
        }
      } catch (e) {
        console.error('Error parsing saved preferences', e);
      }
    }
  }, [hasCheckedSpecialDays]);

  const hasSpecialDays = specialDays.length > 0;

  return (
    <Layout>
      <div className="container mx-auto py-4 sm:py-6 px-4 sm:px-6 max-w-5xl">
        {hasSpecialDays ? (
          <div className="mb-6 sm:mb-8 relative">
            <div className={`absolute -top-3 ${isMobile ? '-left-2' : '-left-3'} h-10 sm:h-12 w-10 sm:w-12 rounded-full bg-primary/20 flex items-center justify-center transform -rotate-12 animate-pulse`}>
              <Gift className={`${isMobile ? 'h-5 w-5' : 'h-6 w-6'} text-primary`} />
            </div>
            <div className={`absolute -top-2 ${isMobile ? '-right-1' : '-right-2'} h-8 sm:h-10 w-8 sm:w-10 rounded-full bg-primary/15 flex items-center justify-center transform rotate-12`}>
              <Calendar className={`${isMobile ? 'h-4 w-4' : 'h-5 w-5'} text-primary`} />
            </div>
            <UpcomingSpecialDays specialDays={specialDays} daysAhead={30} />
          </div>
        ) : (
          <div className="mb-4 sm:mb-6"></div>
        )}
        <UserProfile />
      </div>
    </Layout>
  );
};

export default ProfilePage;
